<template>
  <div>
    <section>
      <single-setting
        id="work-schedule-deadline"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Deadline.svg')"
        title="Deadline"
        :description="$t('deadlineDescription')"
      >
        <template
          v-if="fetchedTeam"
          v-slot:one-column-no-gaps
        >
          <team-work-schedule-deadline-edit
            id="work-schedule-deadline-edit"
            :single-team="fetchedTeam"
            :user-settings="userSettings"
          />
        </template>
      </single-setting>
      <!-- <single-setting
        id="Notifications"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Notifications.svg')"
        :title="$t('notifications')"
        :description="$t('notificationsDesc')"
      >
        <template v-if="fetchedTeam">
          <toggle
            class="toggle"
            :name="$t('emailNotifications')"
            :team-id="fetchedTeam.teamId"
            dbname="notify-days-off"
            :value="settings['notify-days-off']"
          />          
          <toggle
            v-model="pushNotifications"
            class="toggle"
            :name="$t('pushNotifications')"
            :team-id="fetchedTeam.teamId"
            dbname="push-notifications"
          />
          <div class="description">
            {{ $t('pushDescription') }}
          </div>
        </template>
      </single-setting> -->

      <single-setting
        id="working-hours"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Work Schedule.svg')"
        :title="$t('workingDays')"
        :description="$t('workingDaysDesc')"
      >
        <template v-slot:one-column-no-gaps>
          <!-- <editable-input id="working-hours-input"
                                title="Working Hours"
                                v-model="defaultWorkingHoursWeekly"
                                @focus-out="saveToDb('default-working-hours-weekly', ...arguments)"
                                inputType="number"
                                :incorrectValueMsg="$t('incorrectNumerical')"
                                footer="per week"
                                :validationFunction="positiveNumberValid"
                                :restoreValueOnIncorrect="true"/> -->
          <field id="working-days-checkboxes">
            <span
              v-if="fetchedTeam"
              class="checkboxes"
            >
              <checkbox
                v-for="day in weekdays(weekdays().findIndex(x=>x.value === weekStart))"
                :key="day.name"
                class="day-checkbox"
                :content="day.name"
                :inline="true"
                color="blue"
                :initial-state="isChecked(day.name)"
                @input="changeWorkingDays"
              />
            </span>
          </field>
        </template>
      </single-setting>
      <!-- Time off & Holidays settings – TBD --> 
      <!--
      <single-setting
        id="time-off"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Holidays.svg')"
        :title="$t('timeOff')"
        :description="$t('workingHoursDesc')"
      >
        <editable-input
          id="holidays-input"
          v-model="defaultHolidayDaysYearly"
          :title="$t('holidays')"
          input-type="number"
          :incorrect-value-msg="$t('incorrectNumerical')"
          :footer="$t('perYear')"
          :validation-function="positiveNumberValid"
          :restore-value-on-incorrect="true"
          @focus-out="saveToDb('default-holiday-days-yearly', ...arguments)"
        />
        <dropdown
          id="national-holidays-dropdown"
          :title="$t('nationalHolidays')"
          :options="[{ name: 'Poland, National Holidays' }]"
          :value="'Poland, National Holidays'"
        />
      </single-setting>
      -->
    </section>
  </div>
</template>

<script>
import User from '@/components/User'
import Constants from '@/components/Constants'
import SingleSetting from '@/components/Settings/SingleSetting'
// import Toggle from '@/components/UI/Toggle'
import TeamWorkScheduleDeadlineEdit from '@/components/Team/TeamWorkScheduleDeadlineEdit'
import ParseFunctions from '@/components/ParseFunctions'
import Validation from '@/components/Validation'
import Field from '@/components/UI/Field'
import Checkbox from '@/components/UI/Checkbox'

export default {
  name: 'TeamWorkScheduleSettings',
  components: {
    SingleSetting,
    TeamWorkScheduleDeadlineEdit,
    // Toggle,
    Field,
    Checkbox,
  },
  mixins: [User, Constants, ParseFunctions, Validation],
  props: {
    team: {
      default: undefined,
      type: Object,
    },
  },
  data() {
    return {
      settings: {},
      defaultHolidayDaysYearly: '',
      defaultWorkingHoursWeekly: '',
      workingDays: '',
      pushNotifications: '',
      fetchedTeam: null,
      weekStart: 'Monday',
      userSettings: {}
    }
  },
  async created() {
    await this.load()
  },
  methods: {
    async load(){
      this.userSettings = this.$store.state.userSettings
      
      this.fetchedTeam = await this.getTeamById(this.team.teamId)

      this.settings = this.fetchedTeam.settings || {}
      this.defaultHolidayDaysYearly = this.settings['default-holiday-days-yearly'] || '20'
      this.defaultWorkingHoursWeekly = this.settings['default-working-hours-weekly'] || '40'
      this.workingHoursStart = this.settings['working-hours-start'] || '08:00'
      this.workingDays = this.settings['working-days'] || []
      this.pushNotifications = this.settings['push-notifications'] || false      
      this.weekStart = this.userSettings['week-start'] ? this.userSettings['week-start'] : 'Monday'

      let res = await this.userSettingsCLAPI()
      if (res.status === 'ok'){
        this.userSettings = res.settings
        this.weekStart = this.userSettings['week-start'] || this.weekStart
      }else{
        this.showServerError(res)
      }
      
    },    
    async changeWorkingHours(value) {
      // console.log('change workin', value)
      let res = await this.updateTeamSettings(this.fetchedTeam.teamId, 'default-working-hours-weekly', value)
      // console.log('change workin res', res)
    },
    async saveToDb(...arg) {
      let dbname = arg[0]
      let value = arg[1]
      // console.log('saving to db', dbname, value)
      await this.updateTeamSettings(this.fetchedTeam.teamId, dbname, value)
    },
    async changeWorkingDays(value, day) {
      if (this.workingDays.includes(day) && !value) {
        this.workingDays = this.workingDays.filter(d => d !== day)
      } else if (!this.workingDays.includes(day) && value) {
        this.workingDays.push(day)
      }
      await this.updateTeamSettings(this.team.teamId, 'working-days', this.workingDays)
      //// console.log('fetched team', (await this.getTeams(this.team.teamId)).settings['working-days'])
    },
    isChecked(name) {
      // console.log('ischecked', name, this.fetchedTeam.settings['working-days'].includes(name))
      return this.fetchedTeam && this.fetchedTeam.settings['working-days'] && this.fetchedTeam.settings['working-days'].includes(name)
    },
    savedToDb(teamId, name, value) {
      // console.log('saved to db from toggle twss', teamId, name, value)
      let t = this.getTeamById(teamId, teams)
      if (t) {
        t.settings[name] = value
      } else {
        console.error('teamId from dropdown mismatch')
      }
      // console.log('saved to db', t.settings[name])
    },
  },
}
</script>

<style lang="scss">
// Overwriting other templates... :(
#working-days-checkboxes {
  .field-title {
    margin-bottom: 18px;
  }
}
#Notifications {
  .slot {
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 0px !important;

    @include respond-below(sm) {
      display: flex;
      flex-direction: column;
    }

    div:nth-child(1) {
      grid-row: 1;
      grid-column: 1 / 3;
      @include respond-below(sm) {
        margin-bottom: 0;
      }
    }

    div:nth-child(2) {
      grid-row: 2;
      grid-column: 1 / 3;
      margin-bottom: 0;
      
    }

    div:nth-child(3) {
      grid-row: 3;
      grid-column: 1 / 3;
    }

    .description {
      font-size: 14px;
      color: $bluebell;
      line-height: 20px;
      margin-left: 40px;
      }
  }
}
</style>

<style lang="scss" scoped>
section {
  display: flex; // flexbox is sufficient
  flex-direction: column;
  // max-width: 550px;
  margin: 35px;

  .single-setting {
    margin-bottom: 60px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
#working-hours-input {
  grid-row: 1;
  grid-column: 1;
}


#working-days-checkboxes {
  // grid-row: 2;
  // grid-column: 1 / span 3;
  display: inline;
  // margin-top: 14px; // accounting for 'per week' footer

  .day-checkbox {
    &:not(:last-of-type) {
      margin-right: 24px;
    }
    white-space: nowrap;
    line-height: 30px;
    @include respond-below(sm) {
      line-height: 20px; // default checkbox value
    }
  }
}
#holidays-input {
  grid-column: 1;
}
#national-holidays-dropdown {
  grid-column: 2;
}



@include respond-below(sm) {
  section {
    margin: 20px;
    margin-top: 35px;
  }
  .single-setting {
    //width: 322px;
    //width: 100%;
  }
  #team-list-wrapper {
    width: 100%;
  }

  .slot {
    display: flex;
    flex-direction: column;
    width: 100%;

    button {
      /*margin-left: 50px;
            margin-right: 50px;
            width: 220px;*/
      width: 100%;
      font-family: $bold;
      font-size: 16px;
    }
  }

  .checkboxes {
    display: flex;
    flex-direction: column;
    .day-checkbox:first-of-type {
    }
    .day-checkbox:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
}
</style>
